import UsersProfiles from './container';

export default UsersProfiles;



// WEBPACK FOOTER //
// ./src/routes/UsersProfiles/index.js